import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Popover } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";
import { Button, Toggle } from "@ts-digital/vrc";
// import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../../config.js";
import { getInitials } from "../../../libs/utils";
import {
  getSettingsCompany,
  getSettingsCompanyForUser
} from "../../../store/actions/permissions";
import useChangeCompany from "../../../customHooks/useChangeCompany";
import useChangeAccountant from "../../../customHooks/useChangeAccountant";
import "./style.css";
import { FormattedMessage } from "react-intl";
import { logout } from "../../../store/actions/auth/index";
import { LogoutButton } from "@ts-digital/digital-login-component";
import { ENV,TSDIGITAL_ENDPOINT } from "../../../config";
import { GetSelectedCompanyStudio } from "../../../libs/companiesUtils";

const UserBadge = props => {
  const {
    className
  } = props;

  const {changeAccountantSelected} = useChangeAccountant();
  const {changeCompanySelected} = useChangeCompany();
  const studio = useSelector(state => state.studio);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const accountantUuidSelected = useSelector(state => state.main.accountantUuidSelected);
  const accountantIdSelected = useSelector(state => state.main.accountantIdSelected);
  const auth = useSelector(state => state.auth);

  const companySelected = useSelector(state => state.main.companySelected);
  const companyUuidSelected = useSelector(state => state.main.companyUuidSelected);
  const companiesList = useSelector(state => state.company.companies);
  const [visiblePopoverSetting, setVisiblePopoverSetting] = useState(false);
  const [accountantSel, setAccountantSel] = useState(accountantIdSelected);

  const studioList = studio.list;
  const currentStudio = studioList?.find(s => s.uuid === accountantUuidSelected);
  const [companySel, setCompanySel] = useState(companySelected);
  const studioLogoUrl = currentStudio?.logoUrl;

  const currentCompany = companiesList.find(s => s.uuid === companyUuidSelected);
  const companyLogoUrl = currentCompany?.logoUrl;

  const studioFind = GetSelectedCompanyStudio();

  const dispatch = useDispatch();

  let cognomeNome = user?.profile?.lastName
    ? user?.profile?.lastName + " " + user?.profile?.firstName
    : "N/A";

  useEffect(() => {
    if (accountantSel !== accountantIdSelected) {
      dispatch(getSettingsCompany());
      dispatch(getSettingsCompanyForUser(
        companyUuidSelected,
        user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id,
        accountantUuidSelected
      ));
      changeAccountantSelected(accountantSel);
    }
  }, [accountantSel]);

  useEffect(() => {
    if (companySel !== companySelected) {
      dispatch(getSettingsCompany());
      dispatch(getSettingsCompanyForUser(
        companyUuidSelected,
        user?.profile?.uuid ? user?.profile?.uuid : user?.profile?.id,
        accountantUuidSelected
      ));
      changeCompanySelected(companySel);
      changeAccountantSelected(accountantSel);
    }
  }, [companySel]);

  const changeStudio = idStudio => {
    setAccountantSel(idStudio);
    setVisiblePopoverSetting(false);
  };

  const changeCompany = idCompany => {
    setCompanySel(idCompany);
    setVisiblePopoverSetting(false);
  };

  const renderStudioContent = () => {
    let studios = [];
    if (!studioList) return null;
    studioList.map((item, index) => {
      if (item?.additionalData?.status?.status !== "VALIDATED"){
        return null;
      }
      const logoStudioItem = item.logoUrl;
      studios.push(<div key={"studio_"+index}>
        <div
          style={{
            flex: "1 1 auto",
            width: "100%",
            padding: "0px",
            marginTop: "25px"
          }}
        >
          <hr className="hrClass" />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px"
          }}
        >
          <div className="titleClass"><FormattedMessage id="main.userBadge.studio" /></div>
          {studioList.length > 1 ? (
            <div>
              <Toggle
                checked={item.uuid === currentStudio.uuid ? true : false}
                onChange={() => changeStudio(item.id)}
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div style={{ display: "flex", marginLeft: "10px" }}>
          <div>
            {!logoStudioItem ? (
              <div
                style={{ marginRight: "15px", marginTop: "5px" }}
                className="roundUser"
              >
                {item ? getInitials(item.ragioneSociale) : "N/A"}{" "}
              </div>
            ) : (
              <div
                className="logo-studio-container"
                style={{ backgroundImage: `url(${logoStudioItem})` }}
              >
                {" "}
              </div>
            )}
          </div>
          <div>
            <div className="userNameClass" style={{ marginLeft: "0px" }}>
              {item.ragioneSociale}
            </div>
            <div style={{ display: "flex" }}>
              <div><FormattedMessage id="main.userBadge.fiscalCode" />: {item.taxRegion + " " + item.codiceFiscale}</div>{" "}
              <div style={{ marginLeft: "20px" }}>
                <FormattedMessage id="main.userBadge.vatNumber" />: {item.partitaIva}
              </div>
            </div>
          </div>
        </div>
      </div>);
      return null;
    });
    return studios;
  };

  const renderCompanyContent = () => {
    let studios = [];
    companiesList.map((item, index) => {
      const logoCompany = item.logoUrl;
      studios.push(<div key={"company_" + index}>
        <div
          style={{
            flex: "1 1 auto",
            width: "100%",
            padding: "0px",
            marginTop: "20px"
          }}
        >
          <hr className="hrClass" />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px"
          }}
        >
          <div className="titleClass"><FormattedMessage id="main.userBadge.company" /></div>
          {companiesList.length > 1 ? (
            <div>
              <Toggle
                checked={item.uuid === companyUuidSelected ? true : false}
                onChange={() => changeCompany(item.id)}
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div style={{ display: "flex", marginLeft: "10px" }}>
          <div>
            {!logoCompany ? (
              <div
                style={{ marginRight: "15px", marginTop: "5px" }}
                className="roundUser"
              >
                {item ? getInitials(item.ragioneSociale) : "N/A"}{" "}
              </div>
            ) : (
              <div
                className="logo-studio-container"
                style={{ backgroundImage: `url(${logoCompany})` }}
              >
                {" "}
              </div>
            )}
          </div>
          <div>
            <div className="userNameClass" style={{ marginLeft: "0px" }}>
              {item.ragioneSociale}
            </div>
            <div style={{ display: "flex" }}>
              <div><FormattedMessage id="main.userBadge.fiscalCode" />: {item.codiceFiscale}</div>{" "}
              <div style={{ marginLeft: "20px" }}>
                <FormattedMessage id="main.userBadge.vatNumber" />: {item.partitaIva}
              </div>
            </div>
          </div>
        </div>
      </div>);
      return null;
    });
    return studios;
  };

  const renderCardContent = () => {
    // let idToModify = main.myType === "STUDIO" ? accountantIdSelected : companySelected;
    return (
      <div className="card-content">
        <div
          style={{
            display: "flex",
            padding: "8px",
            justifyContent: "space-between"
          }}
        >
          <div className="infoClass"><FormattedMessage id="main.userBadge.information" /></div>
          <div>
            { auth.loginAuth.loginMethod === "digital" ? <Button onClick={() => dispatch(logout())}>
              <FontAwesomeIcon
                icon={faPowerOff}
                style={{
                  marginRight:8
                }}         
              />
              <FormattedMessage id="main.userBadge.logout" />
            </Button> : <LogoutButton
			   buttonText={<div><FontAwesomeIcon
                icon={faPowerOff}
                style={{
				  marginRight:8
                }}
              />
              <FormattedMessage id="main.userBadge.logout" /></div> }
			   env={ENV}
			   mode="redirect"
			   idToken={auth.loginAuth.idToken}
			   redirectUrl={TSDIGITAL_ENDPOINT}
			   
			   beforeLogout={()=> dispatch(logout())}
			 /> }
          </div>
        </div>
        <div style={{ flex: "1 1 auto" }}>
          <hr className="hrHalfDivider" />
        </div>
        <div className="scrollbox">
          <div
            style={{
              display: "flex",
              padding: "8px",
              justifyContent: "space-between"
            }}
          >
            <div className="titleClass"> <FormattedMessage id="main.userBadge.user" /></div>
            {/* <div className = 'linkClass'><FontAwesomeIcon
                    icon={["fal", "pen"]}
                    style={{ color: "#0090d1", fontSize: "16px", cursor: "pointer", marginRight: "8px" }}
                  /> <a
                  href={
                    TSDIGITAL_PORTALE_PUBLIC_URL +
                    "#/" +
                    idToModify +
                    "/edit"
                  }
                  id="goToTSDigital"
                  aria-label={"Link al portale Agyo per la modifica dell'anagrafica"}
                  tabIndex="0"
                >Modifica</a></div> */}
          </div>
          <div className="userNameClass user" style={{ marginBottom: "40px" }}>
            <div className="shortNameRound2">
              {cognomeNome
                .split(" ")
                .map(function(s) {
                  return s.charAt(0);
                })
                .join("")
                .substr(0, 2)}
            </div>
            <div className="userNameClass-text">
              <div className="userNameClass-title">{user?.profile?.firstName} {user?.profile?.lastName}</div>
              <div className="userNameClass-subtitle">{user?.profile?.email} <span>{user?.profile?.language?.split("-")?.[1]}</span></div>
            </div>
          </div>

          {main.myType === "STUDIO" ? renderStudioContent() : renderCompanyContent()}

          <div style={{ flex: "1 1 auto", marginTop: "20px" }}>
            <hr className="hrHalfDivider" />
          </div>
          <div className="linkClass">
            <div
              style={{ cursor: "pointer", color: "#0090d1", padding: "10px" }}
              onClick={() => {
                setVisiblePopoverSetting(false);
                if (window.aptrinsic) {
                  if (main.myType !== "STUDIO") {
                    if (studioFind?.taxRegion === "ES" || user?.profile?.language === "es-ES"){
                      window.aptrinsic("track", "digital-box:APP-DOWNLOAD-COMPANY-ES");
                    } else {
                      window.aptrinsic("track", "digital-box:APP-DOWNLOAD-COMPANY");
                    }
                  } else {
                    if (studioFind?.taxRegion === "ES" || user?.profile?.language === "es-ES"){
                      window.aptrinsic("track", "digital-box:APP-DOWNLOAD-STUDIO-ES");
                    } else {
                      window.aptrinsic("track", "digital-box:APP-DOWNLOAD-STUDIO");
                    }
                  }
                }
              }}
            >
              <FontAwesomeIcon
                icon={["fal", "mobile"]}
                style={{
                  color: "#0090d1",
                  fontSize: "16px",
                  cursor: "pointer",
                  marginRight: "8px",
                  marginTop: "20px"
                }}
              />
              <FormattedMessage id="main.userBadge.downloadApp" />
            </div>
          </div>

          <div
            style={{
              boxShadow: "0 -2px 3px 0 rgba(0,0,0,0.3)",
              width: "100%",
              position: "absolute",
              bottom: "20px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Link
              to={"/profilo"}
              onClick={e => {
                setVisiblePopoverSetting(false);
              }}
              className="profile"
            >
              <div
                style={{
                  cursor: "pointer",
                  height: "32px",
                  color: "rgba(0,0,0,.65)",
                  padding: "5px",
                  fontWeight: 400,
                  margin: "10px 10px 10px 10px"
                  
                }}
              >
                <Button onClick={() => { }} style={{ width: "150px" }}>
                  <FormattedMessage id="main.userBadge.goProfile" />
                </Button>
              </div>
            </Link>
            {main.myType === "STUDIO" && <Link
              to={"/choose-studio"}
              onClick={e => {
                setVisiblePopoverSetting(false);
              }}
              className="profile"
            >
              <div
                style={{
                  cursor: "pointer",
                  height: "32px",
                  color: "rgba(0,0,0,.65)",
                  padding: "5px",
                  fontWeight: 400,
                  margin: "10px 10px 10px 10px"
                  
                }}
              >
                <Button onClick={() => {}} style={{ width: "150px", marginLeft: 16 }}>
                  <FormattedMessage id="main.userBadge.goAccounts" />
                </Button>
              </div>
            </Link>}
          </div>
        </div>
      </div>
    );
  };

  let ragioneSocialeStudio =
    studio &&
    studio.list &&
    studio.list.find(el => el.id === localStorage.getItem("studioSelected"));
  ragioneSocialeStudio = ragioneSocialeStudio
    ? ragioneSocialeStudio.ragioneSociale
    : null;

  return (
    <Popover
      // arrowPointAtCenter={true}
      // getPopupContainer={trigger => trigger.parentNode}
      visible={visiblePopoverSetting}
      onVisibleChange={e => {
        setVisiblePopoverSetting(!visiblePopoverSetting);
      }}
      placement="bottom"
      title={""}
      content={() => renderCardContent()}
      trigger="click"
      overlayClassName="settingsPop"
      overlayStyle={{ width: "526px", height: "calc(100vh - 100px)" }}
    >
      <div
        className={
          "divBadge userBadge user-header" +
          (main.myType === "STUDIO" ? " divBadgeBianco" : "")
        }
      >
        <div className={className}>
          {(main.myType === "STUDIO" && !studioLogoUrl) ||
            (main.myType !== "STUDIO" && !companyLogoUrl) ? (
              <FontAwesomeIcon
                icon={["far", "user"]}
                style={{ fontSize: "24px", marginRight: "40px" }}
              />
            ) : (
              <div
                className="logo-studio-container"
                style={{
                  backgroundImage: `url(${main.myType === "STUDIO" ? studioLogoUrl : companyLogoUrl
                  })`
                }}
              >
                {" "}
              </div>
            )}
          <span
            style={{
              cursor: "pointer",
              fontSize: "16px",
              lineHeight: "20px",
              marginTop: "5px"
            }}
          >
            {user?.profile?.firstName + " " + user?.profile?.lastName}
            {main.myType === "STUDIO" ? (
              <React.Fragment>
                <br />
                <span
                  style={{
                    paddingTop: "4px",
                    fontSize: "12px",
                    fontWeight: 300,
                    lineHeight: 1,
                    color: "#152935",
                    textTransform: "uppercase"
                  }}
                >
                  {ragioneSocialeStudio}
                </span>
              </React.Fragment>
            ) : null}
            {main.myType !== "STUDIO" ? (
              <React.Fragment>
                <br />
                <span
                  style={{
                    paddingTop: "4px",
                    fontSize: "12px",
                    fontWeight: 300,
                    lineHeight: 1,
                    textTransform: "uppercase"
                  }}
                >
                  {currentCompany ? currentCompany.ragioneSociale : ""}
                </span>
              </React.Fragment>
            ) : null}
          </span>
        </div>
      </div>
    </Popover>
  );
};

export default UserBadge;
